import { render } from "./CardReply.vue?vue&type=template&id=7b57cd3c&scoped=true"
import script from "./CardReply.vue?vue&type=script&lang=js"
export * from "./CardReply.vue?vue&type=script&lang=js"

import "./CardReply.vue?vue&type=style&index=0&id=7b57cd3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b57cd3c"]])

export default __exports__